/**
 *
 * @collboard-modules-sdk
 */
export function joinWithAny(values: Array<any>, separator: (key: number) => any): Array<any> {
    return values.reduce((prev, curr, i) => (prev.length ? [...prev, separator(i), curr] : curr), [] as Array<any>);
}
